import { animateGauge } from './animate';
import { describeArc } from './math';
import { isInViewport } from '../helpers/viewport';
import { validateNumber } from './gaugeHelpers';

export function drawGauge(element) {
    if(!element) {
        return;
    }

    let svgElement = element.querySelectorAll('.gauge__svg')[0];
    const colorfullFill = svgElement.querySelectorAll('.gauge__fill')[0];
    const grayFill = svgElement.querySelectorAll('.gauge__background')[0];
    const pointerElement = svgElement.querySelectorAll('.gauge__pointer')[0];
    const targetValue = element.dataset.gaugeStop;

    svgElement.classList.remove('gauge__initiateed');

    const svgConfig = {
        svgElement,
        colorfullFill,
        grayFill,
        pointerElement,
        targetValue
    };

    grayFill.setAttribute("d", describeArc(70, 70, 60, -140, 140));

    // Maybe it is in viewport without scrolling...
    if(isInViewport(svgElement)) {
        initAnimation(svgConfig);
    } else {
        window.addEventListener('scroll', ()=> {
            if(isInViewport(svgElement)) {
                initAnimation(svgConfig);
            }
        });
    }
}

function initAnimation(svgConfig) {
    if(svgConfig.svgElement.getAttribute("class").match('gauge__initiateed')) {
        return;
    }
    let newClassList = `${svgConfig.svgElement.classList} gauge__initiateed`;
    svgConfig.svgElement.setAttribute('class', newClassList);
    svgConfig.colorfullFill.setAttribute("d", describeArc(70, 70, 60, -140, 140));
    animateGauge(0, validateNumber(svgConfig.targetValue), svgConfig.grayFill, svgConfig.pointerElement);
}

